module.exports = __webpack_public_path__ + "img/86052466.01175ee3.png";